// extracted by mini-css-extract-plugin
export default {"timer":"l1-z","loaded":"m1-z"};